import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { useAuthStore } from './lib/store';
import { useSessionManager } from './lib/session';
import Navbar from './components/Navbar';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import Medications from './pages/Medications';
import Reminders from './pages/Reminders';
import MoodTracker from './pages/MoodTracker';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore(state => state.user);
  useSessionManager(); // Add session management
  return user ? <>{children}</> : <Navigate to="/login" />;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Helmet>
            <title>ClearPathRx - Medication Management Made Easy</title>
            <meta name="description" content="Track your medications, set reminders, and monitor your mood with ClearPathRx - your personal medication management assistant." />
            <meta name="theme-color" content="#2563eb" />
            <meta httpEquiv="Content-Security-Policy" content="default-src 'self'; connect-src 'self' https://*.supabase.co; img-src 'self' data: https://*; script-src 'self' 'unsafe-inline' 'unsafe-eval'; style-src 'self' 'unsafe-inline';" />
            <link rel="manifest" href="/manifest.json" />
            <link rel="icon" href="/favicon.ico" />
            <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
          </Helmet>
          <Navbar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/dashboard" element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } />
            <Route path="/medications" element={
              <PrivateRoute>
                <Medications />
              </PrivateRoute>
            } />
            <Route path="/reminders" element={
              <PrivateRoute>
                <Reminders />
              </PrivateRoute>
            } />
            <Route path="/mood" element={
              <PrivateRoute>
                <MoodTracker />
              </PrivateRoute>
            } />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App